import React from 'react';
import { Link } from 'react-router-dom';
import Marquee from '../sections/Marquee';
import AboutSection from '../sections/AboutSection';
import ServicesSection from '../sections/ServicesSection';
import DoshaSection from '../sections/DoshaSection';
import PhilosophySection from '../sections/PhilosophySection';

export default function Home() {
  return (
    <>
      {/* ── HERO ── */}
      <section className="hero">
        {/* Left — copy */}
        <div className="hero-left">
          <p className="hero-eyebrow">Est. 2026 · Kengeri, Bangalore</p>
          <h1 className="hero-title">
            Ancient<br />Wisdom,<br /><em>Everyday</em><br />Healing
          </h1>
          <p className="hero-subtitle">Ayurveda for Everyday Life</p>
          <p className="hero-desc">
            Experience authentic Panchakarma therapies and personalised Ayurvedic care
            at KayaSparsha — Bangalore's newest wellness destination rooted in
            5,000-year-old healing traditions.
          </p>
          <div className="hero-btns">
            <Link to="/treatments" className="btn-outline">Explore Treatments</Link>
          </div>
        </div>

        {/* Right — logo card with decorative orbits */}
        <div className="hero-right">
          <div className="hero-glow" />
          <div className="hero-orbit-wrap">
            <div className="h-orbit"><div className="orbit-dot" /></div>
            <div className="h-orbit" />
            <div className="h-orbit" />
            <div className="hero-logo-card">
              <img src="/images/kayasparsha-logo.png" alt="KayaSparsha" />
            </div>
          </div>
          <div className="hero-stats">
            <div className="stat">
              <div className="stat-number">15<span>+</span></div>
              <div className="stat-label">Treatments</div>
            </div>
            <div className="stat">
              <div className="stat-number">6</div>
              <div className="stat-label">Packages</div>
            </div>
            <div className="stat">
              <div className="stat-number">100<span>%</span></div>
              <div className="stat-label">Authentic</div>
            </div>
          </div>
        </div>
      </section>

      <Marquee />
      <AboutSection />
      <PhilosophySection />
      <ServicesSection />
      <DoshaSection />
    </>
  );
}
